/**
 * Tank Summary Report ids to print with a bottling on History / reprint.
 * The server links them through spirit_bottling_inputs (tankSummaryReportIds);
 * edited bottlings also carry relatedId = bottling id on the report row.
 */
export function bottlingTankSummaryReportIds(
  bottling: { id?: number | string; tankSummaryReportIds?: Array<number | string> | null },
  reports?: Array<{ id?: number | string; relatedId?: number | string | null; relatedRecordType?: string | null }> | null
): number[] {
  const out: number[] = [];
  const add = (v: unknown) => {
    const n = Number(v);
    if (Number.isFinite(n) && n > 0 && !out.includes(n)) out.push(n);
  };
  for (const id of bottling.tankSummaryReportIds || []) add(id);
  for (const r of reports || []) {
    if (
      r.relatedId != null &&
      String(r.relatedId) === String(bottling.id) &&
      String(r.relatedRecordType || '') === 'Bottling'
    ) {
      add(r.id);
    }
  }
  return out;
}
